import React from 'react';
import { Avatar, Tag, Table, message } from 'antd';

const DocumentList = ({ docs, offline = false, currentPage, pageSize, onPaginationChange }) => {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <div className="document-list-name" onClick={() => {
          if (offline) {
            message.warning("You're offline. Connect to the internet to open this grid.");
            return;
          }
          if (!record.attachmentId) return;
          const url = record.path || `https://pad.workw.com/${record.attachmentId}`;
          window.open(url, "_blank", "noopener,noreferrer");
        }}>
          <span className="document-list-name-text">{text || 'Untitled Document'}</span>
        </div>
      ),
    },
    {
      title: 'Author',
      dataIndex: 'creator',
      key: 'creator',
      render: (creator) => (
        <div className="document-list-author">
          <img
            src={creator?.image || `https://ui-avatars.com/api/?background=E0F2FE&color=0C4A6E&name=${encodeURIComponent(creator?.name || 'U')}`}
            alt={creator?.name || 'Unknown'}
            className="document-list-author-img"
          />
          <span className="document-list-author-name">{creator?.name || 'Unknown'}</span>
        </div>
      ),
    },
    {
      title: 'Members',
      dataIndex: 'members',
      key: 'members',
      render: (members) => {
        const memberList = members?.map((memberObj) => ({
          name: memberObj.member.name,
          image: memberObj.member.image || `https://ui-avatars.com/api/?background=3B82F6&color=ffffff&name=${encodeURIComponent(memberObj.member.name.charAt(0))}`,
        })) || [];
        return (
          <Avatar.Group
            maxCount={4}
            size="small"
            maxStyle={{
              color: "var(--surface)",
              backgroundColor: "var(--gray-500)",
              fontSize: "10px",
            }}
          >
            {memberList.map((member, index) => (
              <Avatar
                key={index}
                src={member.image}
                alt={member.name}
                size="small"
                title={member.name}
              >
                {!member.image && member.name.charAt(0).toUpperCase()}
              </Avatar>
            ))}
          </Avatar.Group>
        );
      },
    },
    {
      title: 'Status',
      key: 'status',
      render: (text, record) => {
        const statusLabel = record.status === 6 ? "Draft" : record.status === 7 ? "Completed" : null;
        return statusLabel ? (
          <Tag color="var(--primary-blue)" style={{ borderRadius: "4px", margin: 0, fontSize: "11px", lineHeight: "18px", padding: "1px 4px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", minWidth: "60px" }}>
            {statusLabel}
          </Tag>
        ) : null;
      },
    },
    {
      title: 'Privacy',
      key: 'privacy',
      render: (text, record) => {
        const privacyLabel = record.privacyId === 1 ? "Public" : record.privacyId === 2 ? "Private" : null;
        return privacyLabel ? (
          <Tag color="var(--primary-blue)" style={{ borderRadius: "4px", margin: 0, fontSize: "11px", lineHeight: "18px", padding: "1px 4px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", minWidth: "60px" }}>
            {privacyLabel}
          </Tag>
        ) : null;
      },
    },
    {
      title: 'Modified',
      dataIndex: 'updateDate',
      key: 'updateDate',
      render: (date) => new Date(date || Date.now()).toLocaleDateString(),
    },
    {
      title: 'Created',
      dataIndex: 'createDate',
      key: 'createDate',
      render: (date) => new Date(date || Date.now()).toLocaleDateString(),
    },
    {
      title: 'Size',
      dataIndex: 'fileSize',
      key: 'size',
      render: (fileSize) => {
        return fileSize ? `${fileSize} words` : "0 KB";
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={docs}
      rowKey="id"
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        showSizeChanger: true,
        showQuickJumper: true,
        onChange: onPaginationChange,
        onShowSizeChange: onPaginationChange,
      }}
      size="small"
      scroll={{ x: 800 }}
      className="document-list-table"
    />
  );
};

export default DocumentList;